import React, { useState, useEffect } from 'react';
import MarginHeader from './marginHeader';
const headerStyle = {
    backgroundColor: '#004080',
    color: '#fff',
    fontSize: '14px',
    fontFamily: 'Roboto Regular',
    fontWeight: 'normal',
    borderRight: '1px solid rgb(255 255 255 / 50%)',
    verticalAlign: 'middle',
    textAlign: 'center',
};

const tdStyle = {
    background: '#f5f5f5',
    borderBottom: '1px solid #ccc',
    borderRight: '1px solid rgb(255 255 255 / 50%)',
    padding: '5px 10px',
    color: '#333',
    fontSize: '12px',
};

const totalRowStyle = {
    background: '#fff',
    color: '#000',
    fontWeight: 'bold',
    textAlign: 'right',
    fontSize: '12px',
    padding: '10px',
};

const footerStyle = {
    borderTop: '2px solid #d5d5d5',
    textAlign: 'center',
    fontSize: '12px',
    padding: '10px 0',
    margin: 0,
};
const totalTd = {
    fontFamily: "Roboto Black",
    borderTop: '1px solid #000',
    borderBottom: '1px solid #000',
    // padding:"1px",
    fontSize: "13px"
}

const formatAmount = (amount) => {
    const formattedAmount = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.abs(Number(amount)) || 0);
    return Number(amount) < 0 ? `(${formattedAmount})` : formattedAmount;
};
const formatAmountSixdigitDecimal = (amount) => {
    const formattedAmount = new Intl.NumberFormat('en-US', { minimumFractionDigits: 6, maximumFractionDigits: 6 }).format(Math.abs(Number(amount)) || 0);
    return Number(amount) < 0 ? `(${formattedAmount})` : formattedAmount;
};

const NonMarginTable = ({ marginDetails, clientAddressDetails, fromDate, toDate, grandTotalMarketValueMarginSecurities, grandTotalMarginAmount }) => {
    const [tableData, setTableData] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(9); // Adjust this if necessary

    useEffect(() => {
        const generateTableData = () => {
            const rows = [];
            marginDetails?.forEach((item) => {
                const { currencydesc, items, totalInvestmentCost, totalMarketValue, totalUnrealizedGainLoss, totalMarginAmount, totalMarketValueMarginSecurities } = item;
                rows.push({ currencydesc, isCurrencyRow: true });
                items.forEach((transaction) => {
                    rows.push(transaction);
                });
                rows.push({
                    comments: 'TOTAL',
                    totalInvestmentCost: parseFloat(totalInvestmentCost).toFixed(2),
                    totalMarketValue: parseFloat(totalMarketValue).toFixed(2),
                    totalUnrealizedGainLoss: parseFloat(totalUnrealizedGainLoss).toFixed(2),
                    totalMarginAmount: parseFloat(totalMarginAmount).toFixed(2),
                    totalMarketValueMarginSecurities: parseFloat(totalMarketValueMarginSecurities).toFixed(2),

                });

            });
            rows.push({
                comments: 'GRANDTOTAL',
                grandTotalMarginAmount: parseFloat(grandTotalMarginAmount).toFixed(2),
                grandTotalMarketValueMarginSecurities: parseFloat(grandTotalMarketValueMarginSecurities).toFixed(2),
            });
            setTableData(rows);
        };

        generateTableData();
    }, [marginDetails, grandTotalMarginAmount, grandTotalMarketValueMarginSecurities]);

    const paginateTableData = (data, rowsPerPage) => {
        const paginatedData = [];
        for (let i = 0; i < data.length; i += rowsPerPage) {
            const page = data.slice(i, i + rowsPerPage);
            // Keep pages with actual data rows or summary rows, but skip header-only slices.
            const hasVisibleRows = page.some(
                (row) => row && (row.securityName || row.comments === 'TOTAL' || row.comments === 'GRANDTOTAL')
            );
            if (hasVisibleRows) {
                paginatedData.push(page);
            }
        }
        return paginatedData;
    };

    const paginatedTableData = paginateTableData(tableData, rowsPerPage);

    return (

        <div>
            {paginatedTableData.map((page, pageIndex) => {
                const hasContent = page.length > 0;
                return (
                    <div
                        key={pageIndex}
                        style={{
                            pageBreakAfter: pageIndex < paginatedTableData.length - 1 ? 'always' : 'auto',
                            pageBreakInside: 'avoid',
                            padding: '0',
                            margin: '0',
                        }}
                    >
                        <header>
                            <MarginHeader clientAddressDetails={clientAddressDetails} fromDate={fromDate}
                                toDate={toDate} />
                        </header>
                        <hr />
                        <main style={{ minHeight: '440px', pageBreakInside: 'avoid', padding: '0' }}>
                            <table
                                className="table"
                                style={{
                                    width: '100%',
                                    borderCollapse: 'collapse',
                                    pageBreakInside: 'avoid',
                                }}
                            >
                                <thead>
                                    <tr>
                                        <th style={{ ...headerStyle, minWidth: "170px" }}>Security Name</th>
                                        <th style={{ ...headerStyle }}>Quantity</th>
                                        <th style={{ ...headerStyle }}>Average Price</th>
                                        <th style={{ ...headerStyle }}>Market Price</th>
                                        <th style={{ ...headerStyle }}>Investment Cost</th>
                                        <th style={{ ...headerStyle }}>Client Funding (%)</th>
                                        <th style={{ ...headerStyle }}>Margin Amount (AED)</th>
                                        <th style={{ ...headerStyle }}>Market Value Margin Securities (AED)</th>
                                        <th style={{ ...headerStyle }}>Market Value</th>
                                        <th style={{ ...headerStyle }}>Unrealized Gain/(Loss)</th>
                                        <th style={{ ...headerStyle }}>Margin Concentration (%)</th>
                                    </tr>

                                </thead>
                                <tbody>
                                    {page.map((row, index) => (
                                        <React.Fragment key={index}>

                                            {row.isCurrencyRow ? (
                                                <tr style={{ backgroundColor: '#e7f3fe' }}>
                                                    <td colSpan={11} className="td-colors bg-white border-0 table-split-head moble-thead-change">
                                                        {row.currencydesc}
                                                    </td>
                                                </tr>
                                            ) : row.comments === 'TOTAL' ? (
                                                <tr style={{ borderBottom: '1px solid #fff', background: '#d9edf7' }}>
                                                    <td style={totalRowStyle} colSpan={4}>Total</td>
                                                    <td style={{ ...totalRowStyle, borderTop: '1px solid #000', borderBottom: '1px solid #000' }}>
                                                        <span style={{ color: Number(row.totalInvestmentCost) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmount(row.totalInvestmentCost)}
                                                        </span>
                                                    </td>
                                                    <td colSpan={2} style={{ ...totalRowStyle, borderTop: '1px solid #000', borderBottom: '1px solid #000' }}>
                                                        <span style={{ color: Number(row.totalMarginAmount) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmount(row.totalMarginAmount)}
                                                        </span>
                                                    </td>
                                                    <td style={{ ...totalRowStyle, borderTop: '1px solid #000', borderBottom: '1px solid #000' }}>
                                                        <span style={{ color: Number(row.totalMarketValueMarginSecurities) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmount(row.totalMarketValueMarginSecurities)}
                                                        </span>
                                                    </td>
                                                    <td style={{ ...totalRowStyle, borderTop: '1px solid #000', borderBottom: '1px solid #000' }}>
                                                        <span style={{ color: Number(row.totalMarketValue) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmount(row.totalMarketValue)}
                                                        </span>
                                                    </td>
                                                    <td style={{ ...totalRowStyle, borderTop: '1px solid #000', borderBottom: '1px solid #000' }}>
                                                        <span style={{ color: Number(row.totalUnrealizedGainLoss) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmount(row.totalUnrealizedGainLoss)}
                                                        </span>
                                                    </td>
                                                    <td>

                                                    </td>
                                                </tr>
                                            ) : row.comments === 'GRANDTOTAL' ? (
                                                <tr style={{ borderBottom: '1px solid #fff', background: '#d9edf7' }}>
                                                    <td style={totalRowStyle} colSpan={6}>Grand Total</td>
                                                    <td style={{ ...totalRowStyle, borderBottom: '1px solid #000' }}>
                                                        <span style={{ color: Number(row.grandTotalMarginAmount) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmount(row.grandTotalMarginAmount)}
                                                        </span>
                                                    </td>
                                                    <td colSpan={1} style={{ ...totalRowStyle, borderBottom: '1px solid #000' }}>
                                                        <span style={{ color: Number(row.grandTotalMarketValueMarginSecurities) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmount(row.grandTotalMarketValueMarginSecurities)}
                                                        </span>
                                                    </td>
                                                    <td></td>
                                                    <td></td>
                                                    <td></td>

                                                </tr>
                                            ) : (
                                                <tr >
                                                    <td style={tdStyle}>{row.securityName}</td>
                                                    <td style={{ ...tdStyle, textAlign: "right" }}>
                                                        <span style={{ color: Number(row.quantity) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmount(row.quantity)}
                                                        </span>
                                                    </td>
                                                    <td style={{ ...tdStyle, textAlign: "right" }}>
                                                        <span style={{ color: Number(row.avgPrice) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmountSixdigitDecimal(row.avgPrice)}
                                                        </span>
                                                    </td>
                                                    <td style={{ ...tdStyle, textAlign: "right" }}>
                                                        <span style={{ color: Number(row.marketPrice) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmountSixdigitDecimal(row.marketPrice)}
                                                        </span>
                                                    </td>
                                                    <td style={{ ...tdStyle, textAlign: "right" }}>
                                                        <span style={{ color: Number(row.investmentCost) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmount(row.investmentCost)}
                                                        </span>
                                                    </td>
                                                    <td style={{ ...tdStyle, textAlign: "right" }}>
                                                        <span style={{ color: Number(row.clientFunding) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmount(row.clientFunding)}
                                                        </span>
                                                    </td>
                                                    <td style={{ ...tdStyle, textAlign: "right" }}>
                                                        <span style={{ color: Number(row.marginAmount) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmount(row.marginAmount)}
                                                        </span>
                                                    </td>
                                                    <td style={{ ...tdStyle, textAlign: "right" }}>
                                                        <span style={{ color: Number(row.marketValueMarginSecurities) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmount(row.marketValueMarginSecurities)}
                                                        </span>
                                                    </td>
                                                    <td style={{ ...tdStyle, textAlign: "right" }}>
                                                        <span style={{ color: Number(row.marketValue) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmount(row.marketValue)}
                                                        </span>
                                                    </td>
                                                    <td style={{ ...tdStyle, textAlign: "right" }}>
                                                        <span style={{ color: Number(row.unrealizedgainloss) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmount(row.unrealizedgainloss)}
                                                        </span>
                                                    </td>
                                                    <td style={{ ...tdStyle, textAlign: "right" }}>
                                                        <span style={{ color: Number(row.marginConcentration) < 0 ? '#E43740' : 'black' }}>
                                                            {formatAmount(row.marginConcentration)}
                                                        </span>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>

                                    ))}

                                </tbody>
                            </table>
                        </main>
                        {hasContent && (
                            <footer style={footerStyle}>
                                <div>A Subsidiary of DUBAI INVESTMENTS</div>
                                <div>
                                    {clientAddressDetails.building}, {clientAddressDetails.street}, {clientAddressDetails.citya}, {clientAddressDetails.countrya}.
                                    Office {clientAddressDetails.officeno}, P.O. Box-{clientAddressDetails.postbox}, Tel: {clientAddressDetails.mobile},
                                </div>
                                <div>Al Mal Capital PSC is Registered with Federal Tax Authority with VAT Number {clientAddressDetails.trnno || 'N/A'}</div>
                                <div>Al Mal Capital PSC is incorporated in Dubai UAE under CR 76761 as a Private Joint Stock Company with a paid-up share capital of AED 219.78 Million</div>
                                <div>(Al Mal Capital PSC is licensed and regulated by the Securities and Commodities Authorities, License No# 603022)</div>
                            </footer>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default NonMarginTable;
